import { render, staticRenderFns } from "./AddUpdates.vue?vue&type=template&id=83ca05e4"
import script from "./AddUpdates.vue?vue&type=script&lang=js"
export * from "./AddUpdates.vue?vue&type=script&lang=js"
import style0 from "./AddUpdates.vue?vue&type=style&index=0&id=83ca05e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports